import { RootState } from '../store/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  ILogin,
  IUser,
  IUserResponse,
} from '../common/interfaces/iUser.interface';

const API_HOST = process.env.REACT_APP_API_HOST || 'http://localhost:4000';
const API_BASE_URL = `${API_HOST}/v1/`;

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: 'include',
    prepareHeaders: async (headers, { getState }) => {
      // const token = (getState() as RootState).user.info.api_token;
      // if (token) {
      //   headers.set('Authorization', `Bearer ${token}`);
      // }
      return headers;
    },
  }),
  endpoints: build => ({
    login: build.mutation<IUserResponse, ILogin>({
      transformResponse: (response: { data: IUserResponse }) => response.data,
      query: data => ({
        url: '/auth/sign-in',
        method: 'POST',
        body: data,
      }),
    }),
    forgotPassword: build.mutation<any, { email: string }>({
      transformResponse: (response: { data: any }) => response.data,
      query: email => ({
        url: '/auth/forgot-password',
        method: 'POST',
        body: email,
      }),
    }),
    signUp: build.mutation<any, any>({
      transformResponse: (response: { data: any }) => response.data,
      query: data => ({
        url: '/auth/sign-up',
        method: 'POST',
        body: data,
      }),
    }),
    // getUser: build.query<IUser, string>({
    //   transformResponse: (response: { data: IUser }) => response.data,
    //   query: () => ({
    //     url: '/user/get',
    //     method: 'GET',
    //   }),
    // })
  }),
});
